import React, { useCallback } from 'react'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import FieldLabelWrapperComponent from '../../../../../../features/components/Form/FieldLabelWrapper'
import FacebookAndTikTokBudgetFields from './FacebookAndTikTokBudgetFields'
import FieldComponent from '../../../../../../components/Form/Field'

import {
  selectedFacebookAdAccountSelector,
  selectedTikTokAdAccountSelector
} from '../../../../../../modules/selectors/adAccounts'

import { TIKTOK_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { FACEBOOK_AND_TIKTOK } from '../PlatformsFieldWrapper/fields'

import { budgetFields } from './styles.css'
import { PLATFORMS } from '../fields'

const FieldLabelWrapper = FieldLabelWrapperComponent as any
const Field = FieldComponent as any

interface BudgetFieldsWrapperProps {
  formik: FormikProps<any>
}

const BudgetFieldsWrapper: React.FC<BudgetFieldsWrapperProps> = ({ formik }) => {
  const { t } = useTranslation()

  const { currency_symbol: facebookCurrencySymbol } = useSelector(selectedFacebookAdAccountSelector)
  const { currency_symbol: tiktokCurrencySymbol } = useSelector(selectedTikTokAdAccountSelector)

  const { values } = formik

  const renderBudgetField = useCallback(() => {
    if (values[PLATFORMS] === FACEBOOK_AND_TIKTOK) {
      return <FacebookAndTikTokBudgetFields formik={formik} />
    } else if (values[PLATFORMS] === TIKTOK_PLATFORM) {
      return (
        <Field
          formik={formik}
          id={'BUDGET_TIKTOK'}
          name={'BUDGET_TIKTOK'}
          placeholder="Budget"
          symbol={tiktokCurrencySymbol}
        />
      )
    } else {
      return (
        <Field
          formik={formik}
          id={'BUDGET_FACEBOOK'}
          name={'BUDGET_FACEBOOK'}
          placeholder="Budget"
          symbol={facebookCurrencySymbol}
        />
      )
    }
  }, [formik, values, facebookCurrencySymbol, tiktokCurrencySymbol])

  return (
    <FieldLabelWrapper
      className={budgetFields}
      label={t('Budget')}
      description={t('Your remaining allowance is £5,000')}
      horizontalView={true}
      helpText={t('Help text will go here...')} // todo add correct help text
    >
      {renderBudgetField()}
    </FieldLabelWrapper>
  )
}

export default BudgetFieldsWrapper
